<input type="file" class="d-none" #fileInput (input)="fileSelected($event)"/>

@if (layout === 'btn-first' || layout === 'btn-only') {
  <ng-container [ngTemplateOutlet]="downloadBtn"></ng-container>
}

@if (layout !== 'btn-only') {
  <ul class="list-group" [class.mb-2]="layout === 'list-first'" [class.mt-2]="layout === 'btn-first'">
    @for (privateAttachment of privateAttachments; track privateAttachment.id) {
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <div class="file-upload-list-item w-100">
          <div class="file-upload-list-item-text text-truncate">
            {{ privateAttachment.name }}
          </div>
          <div class="file-upload-list-item-buttons text-end">
            <div class="btn-group btn-group-sm">
              <button
                class="btn btn-sm btn-primary"
                (click)="openFile(privateAttachment)"
                type="button">
                <i class="fa fa-download"></i>
              </button>

              <button
                class="btn btn-sm btn-danger"
                [disabled]="readonly"
                (click)="remove(privateAttachment)"
                type="button">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </li>
    }
  </ul>
}


@if (layout === 'list-first') {
  <ng-container [ngTemplateOutlet]="downloadBtn"></ng-container>
}

<ng-template #downloadBtn>
  @if (showUploadButton) {
    <button
      type="button"
      class="btn btn-primary w-100"
      (click)="openUpload()"
      [disabled]="readonly || (uploadsAllowed$ | async) === false">
      {{ btnTranslateKey | translate }}
    </button>
  }
</ng-template>
